export default __webpack_public_path__ + "static/media/css3.5447a478.png";